var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-square-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.17226 21.4275H14.8294C19.5437 21.4275 21.4294 19.5417 21.4294 14.8275V9.17031C21.4294 4.45603 19.5437 2.57031 14.8294 2.57031H9.17226C4.45798 2.57031 2.57227 4.45603 2.57227 9.17031V14.8275C2.57227 19.5417 4.45798 21.4275 9.17226 21.4275Z",
    fill: "#A020FF",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4349 15.7378C10.2349 15.7378 10.0449 15.6578 9.90492 15.5178L7.07492 12.6878C6.78492 12.3978 6.78492 11.9178 7.07492 11.6278C7.36492 11.3378 7.84492 11.3378 8.13492 11.6278L10.4349 13.9278L15.5749 8.78781C15.8649 8.49781 16.3449 8.49781 16.6349 8.78781C16.9249 9.07781 16.9249 9.55781 16.6349 9.84781L10.9649 15.5178C10.8249 15.6578 10.6349 15.7378 10.4349 15.7378Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleChecked);
export default __webpack_public_path__ + "static/media/PurpleChecked.ba9b6e65179f98d00f7f29483134ac97.svg";
export { ForwardRef as ReactComponent };